import { render, staticRenderFns } from "./add-candidate.vue?vue&type=template&id=93481e0a&scoped=true"
import script from "./add-candidate.vue?vue&type=script&lang=ts"
export * from "./add-candidate.vue?vue&type=script&lang=ts"
import style0 from "./add-candidate.vue?vue&type=style&index=0&id=93481e0a&prod&lang=scss"
import style1 from "./add-candidate.vue?vue&type=style&index=1&id=93481e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93481e0a",
  null
  
)

export default component.exports